// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2U0jF","search":"Settings_search__3wDyC","filter":"Settings_filter__OHX8l"};